import React, { useEffect, useState } from 'react';
import {
  Button,
  FormInput,
  FormNumber,
  FormSelect,
  FormSubmitButton,
  FormSwitch,
  MasterDetailForm,
  Row,
} from '@digital/ui';
import { Modal } from 'antd';
import { BidCycleItem, update } from '@app/api/bidCycle';
import CurrencyInput from '@app/components/CurrencyInput';
import { optionsTipo } from '@app/api/demanda';
import { FluxoProcessoOptions, getBidFluxoProcessoEtapa } from '@app/api/FluxoProcesso'
import { Visibility } from '@app/components';
import { compareText } from '@app/helpers/comparators';

interface Props {
  idPai: string | null;
  item: BidCycleItem | null;
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  onUpdate: () => void;
  setItem: React.Dispatch<React.SetStateAction<BidCycleItem | null>>;
  fluxoProcessoOptions: FluxoProcessoOptions[] | undefined;
}


const ModalUpdateItem = (props: Props) => {
  const { idPai, item, showModal, setShowModal, onUpdate, setItem } = props;
  const [clear, setClear] = useState(false);
  const [tempFluxoProcessoOptions, setTempFluxoProcessoOptions] = useState<FluxoProcessoOptions[]>()

  const submit = (values: any) => {
    update({ ...values, itemPaiId: idPai }).then(data => {
      if (data.valid) {
        setShowModal(false);
        onUpdate();
        setItem(null);
        setClear(true);
        setClear(false);
      }
    });
  };

  useEffect(() => {
    if (props && props.fluxoProcessoOptions && idPai != null) {
      getBidFluxoProcessoEtapa(idPai).then(data => {
        if (data != null) {
          if (item != null && item.fluxoProcessosEtapas != null) {
            let aux = data.filter(a => {
              return item.fluxoProcessosEtapas.indexOf(a) < 0;
            })

            setTempFluxoProcessoOptions(props.fluxoProcessoOptions.filter(e => {
              return aux.indexOf(e.value) < 0;
            }))
          } else {
            setTempFluxoProcessoOptions(props.fluxoProcessoOptions.filter(e => {
              return data.indexOf(e.value) < 0;
            }))
          }
        }
      });
    }
  }, [item, idPai]);

  return (
    <>
      <Modal visible={showModal} width="960px" onCancel={() => setShowModal(false)} footer={null}>
        {!clear && (
          <MasterDetailForm
            initialValues={item}
            onSubmit={submit}
            actions={[
              <Button type="link" onClick={() => setShowModal(false)}>
                Cancelar
              </Button>,
              <FormSubmitButton type="primary" noIcon>
                Salvar
              </FormSubmitButton>,
            ]}>
            <Row style={{ padding: '20px' }}>
              {idPai ? (
                <Row>
                  <FormInput name="descricao" label="Descrição" span={12} />
                </Row>
              ) : (
                <Row>
                  <FormSelect options={optionsTipo} name="tipo" label="Processo" span={4} style={{ width: '100%' }} />
                  <FormSwitch name="analiseFinanceira" label="Será Necessária Análise Financeira?" span={4} />
                  <FormSwitch name="analiseCompliance" label="Será Necessária Análise de Compliance?" span={4} />
                </Row>
              )}

              {idPai ? (
                <Row>
                  <FormNumber name="visitaTecnica" label="Visita Técnica" span={4} />
                  <FormNumber name="diasDirecionamentoFornecedor" label="Dias Direcionamento Fornecedor" span={4} />
                  <FormNumber name="duracaoTotal" label="Duração Total" span={4} />
                  <FormNumber name="elegibilidadeGovernanca" label="Elegibilidade Governança" min={0} max={99} span={4} />
                </Row>
              ) : (
                <Row>
                  <FormNumber name="minimoProponentes" label="Mínimo de Proponentes" span={4} />
                  <CurrencyInput name="valorDe" label="Valor de" span={4} />
                  <CurrencyInput name="valorAte" label="Valor até" span={4} />
                </Row>
              )}
            </Row>
            <Visibility
              visible={idPai != null}
            >
              <Row style={{ padding: '20px' }}>
                <FormSelect
                  showSearch
                  mode="multiple"
                  label="Etapas Fluxo Processos"
                  name="fluxoProcessosEtapas"
                  options={tempFluxoProcessoOptions && tempFluxoProcessoOptions.sort((a, b) => compareText(a.text, b.text))}
                  span={12}
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                  }}
                />
              </Row>
            </Visibility>
          </MasterDetailForm>
        )}
      </Modal>
    </>
  );
};

export default ModalUpdateItem;
